"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var debounce_1 = require("./debounce");
var lodash_1 = require("lodash");
var useSearch = function (onRemoveFilter, onSearch, searchText) {
    var debouncedSearch = (0, debounce_1.useDebounce)(searchText, 500);
    (0, react_1.useEffect)(function () {
        if ((0, lodash_1.isEmpty)(searchText)) {
            onRemoveFilter && onRemoveFilter("search");
        }
        else {
            onSearch && onSearch(debouncedSearch);
        }
    }, [debouncedSearch]);
};
exports.default = useSearch;
//# sourceMappingURL=search.js.map